import Comment from '../templates/Comment'

const RespondPublication = ({data}) => {
  return <Comment isAnswer data={data} />
}

export default RespondPublication
